(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('cancellationService', cancellationService);

	function cancellationService($q, _) {
		function createCancellationSource() {
			var deferred = $q.defer();
			var token = deferred.promise;
			token.isCancelled = false;

			token.whenCanceled = function (callback) {
				return token.then(callback);
			};

			return {
				token: token,
				cancel: function () {
					deferred.resolve();
					token.isCancelled = true;
				}
			};
		}

		function withToken(callback, token) {
			return _.partialRight(callback, token);
		}

		function cancelWhenDestroyed(cancellationSource, scope) {
			var unwatch = scope.$on('$destroy', cancellationSource.cancel);
			return unwatch;
		}

		return {
			createCancellationSource: createCancellationSource,
			withToken: withToken,
			cancelWhenDestroyed: cancelWhenDestroyed
		};
	}
	cancellationService.$inject = ['$q', '_'];
})();